import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.linkedin.com/in/spinozadelva/"
        className="home__social-link"
        target="_blank"
        rel="noreferrer"
      >
        <i className="uil uil-linkedin-alt"></i>
        <span className="home__social-text">LinkedIn</span>
      </a>

      <a
        href="https://github.com/SpinozaDelva"
        className="home__social-link"
        target="_blank"
        rel="noreferrer"
      >
        <i className="uil uil-github-alt"></i>
        <span className="home__social-text">GitHub</span>
      </a>
    </div>
  );
};

export default Social;